import React, {useEffect, useMemo, useState} from 'react';
import {Card, Col, Row} from 'react-bootstrap';
import Chart from 'react-apexcharts';
import 'react-datepicker/dist/react-datepicker.css';
import ApiUtils from 'api/ApiUtils';

const EventEngagement = (): any => {
  const [cardData, setCardData]: any = useState<any[]>([]);

  const fetchDashboardData = async (): Promise<void> => {
    const resp: any = await ApiUtils.getEventEngagementChart();
    setCardData(Array.isArray(resp?.data) ? resp.data : []); // Ensure it's always an array
  };

  useEffect(() => {
    void fetchDashboardData();
  }, []);

  // 🏆 Optimized: Use `useMemo` to compute `series` & `events` in one loop
  const {series, events} = useMemo(() => {
    if (!Array.isArray(cardData)) return {series: [], events: []}; // Prevent errors

    const extractedEvents: string[] = [];
    const extractedSeries: number[] = [];

    cardData?.forEach((element: any) => {
      extractedEvents.push(element?.event_name);
      extractedSeries.push(element?.guest_count);
    });

    return {
      events: extractedEvents,
      series: [
        {
          name: 'Guests count',
          data: extractedSeries,
        },
      ],
    };
  }, [cardData]);

  console.log('eventsevents', events);

  const options = {
    chart: {
      height: 400,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
    },
    title: {
      text: `Guest list by event`,
      align: 'left',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'],
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: events, // Memoized value
    },
  };

  return (
    <Col xxl={12} className="order-last">
      <Card>
        <Card.Header className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1 text-start">
            Event engagement : Guest List By event
          </h4>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col xxl={12}>
              <Chart
                options={options}
                series={series}
                type="line"
                height="405"
                className="apex-charts"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default EventEngagement;
